import styles from './companies-created.module.scss';
import { CreateHeaders, dateHeader, HeaderSizeEnum, textHeader } from '@frontend-workspace/react-shared-lib';
import { UseTableHook } from '../requestUtils';
import { Col, Row } from 'reactstrap';
import WebkuaTable from '../webkua-table/webkua-table';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface CompaniesCreatedProps { }

export function CompaniesCreated(props: CompaniesCreatedProps) {
  const { data, getData, dateRange, onDateChange } = UseTableHook(`admin/newCompanies`, { ignoreCompany: true });
  const { t } = useTranslation();
  return (
    <Row>
      <Col>
        <h4 className='mt-5 mb-3 mb-sm-0 MuiTypography-h5'>{t("standard.newCompanies")}</h4>
        <WebkuaTable
          headers={CreateHeaders([
            dateHeader("activationDate", t("standard.activated")),
            textHeader("companyName", t("standard.name"), HeaderSizeEnum.EXTRA_LARGE),
            textHeader("companyNumber", t("standard.companyNo"), HeaderSizeEnum.MEDIUM),
            textHeader("createdBy", t("standard.createdBy"), HeaderSizeEnum.LARGE),
            textHeader("adminEmail", t("companiesCreated.adminEmail"), HeaderSizeEnum.EXTRA_LARGE),
            textHeader("adminName", t("companiesCreated.adminName"), HeaderSizeEnum.LARGE),
            textHeader("orgnr", t("standard.organisationNumber"), HeaderSizeEnum.MEDIUM),
            textHeader("errorText", t("standard.errorText"), HeaderSizeEnum.EXTRA_LARGE)
          ])}
          data={data}
          dateRange={dateRange}
          onSetDateRange={onDateChange}
          onRefresh={getData}
        />
      </Col>
    </Row>
  );
}

export default CompaniesCreated;